import React,{useState,useEffect} from 'react'
import "./ViewBookComponent.css"
import { setting } from '../../Common/BookImagesCaourosalSetting'
import Slider from 'react-slick'
import { useSelector } from 'react-redux'
import userApi from '../../Common/Api/UserApi'
import Cookies from 'universal-cookie'
import { Link } from 'react-router-dom'


export default function ViewBookComponent({book}) {

    const {BookWormUser} = useSelector((state)=>state);

    console.log(book)

    const cookies =new Cookies();
    const handleAddtoCart = async () => {

        userApi.post('/user/add-to-cart', {
          user: {
            _id: BookWormUser.userInfo._id
          },
          adId: book._id
        },
          {
            headers: {
              'Authorization': `Bearer ${cookies.get('token')}`
            }
          }).then().catch(err => {
            console.log('status : ', err);
            if (err.response.status == 404) {
              // setInCart(true);
    
              alert("This Item already Exists in your Cart");
            }
          })
    
      }

      const [toBuy,setToBuy] = useState([]);
      useEffect(() => {
    
        setToBuy([{id:book._id, price:book.quotedPrice,title:book.title ,img:book.images[0] }])
    
      }, [])

  return (
      <div className='ViewBookComponent'>
          <div className="BookContainer BookImagesContainer ">
              <Slider {...setting} >
                  {
                      book.images.map((image) => {
                          return (<div >
                          <img src={image} className='BookImage' alt="Book" key={image.id} />
                          </div>)
                        })
                  }
              </Slider>
          </div>
          <div className="BookContainer BookInfoContainer ">
              <div className="section1">
                  <span style={{backgroundColor:"lightblue", padding:"2px 8px", color:"green",margin: "10px 0px",display: "block", width: "fit-content", border:"1px solid lightblue",borderRadius:"4px"}}>In stock</span>
                  <h2>{book.title}</h2>
                  
          <span>Author : <strong>{book.authors.map((author) => {
                        return author + " ";
                  })}</strong></span>&nbsp;&nbsp;
                  <span> No. of pages : <strong>{book.totalPages}</strong></span>
              </div>
              <hr />
              <div className="section2">
                  <span>Price : <strong style={{ color: "#ff5757" }} >{book.quotedPrice}rs</strong></span>
                  {/* <p className='text' >Lorem ipsum, dolor sit amet consectetur adipisicing elit. Illo optio error eaque tempore quo, nostrum fuga eligendi. Amet, ex? Ut ipsum a rerum, iste rem eligendi ullam esse mollitia similique?</p> */}
                  <p>Location : <strong>{ book.location}</strong></p>
                  <p>Edition : <strong>{ book.edition}</strong></p>
              </div>
              <hr />
              <div className="section3">
                  <button style={{marginLeft:"0rem"}} className="btn btn-success BookButtons" onClick={handleAddtoCart}> <i className ="fa-solid fa-cart-shopping "></i> Add to Cart</button>
                  <button className="btn btn-success BookButtons"><Link  state={{books:toBuy}} to='/checkout' style={{color:"white"}}><i className="fa-solid fa-bag-shopping "></i> Buy Now</Link></button>
              </div>
              <hr />
              <div className="section4">
          <span>Categories : <strong>{book.categories.map((category) => { return category.name + " "; })}</strong></span>
                  <p><i style={{color:"#3b5998"}} className="fa-brands fa-facebook fa-2x"></i><i style={{color:"#1DA1F2"}} className="fa-brands fa-twitter fa-2x"></i><i style={{color:"#E1306C"}} className="fa-brands fa-instagram fa-2x"></i><i style={{color:"#0072b1"}} className="fa-brands fa-linkedin fa-2x"></i></p>
              </div>
              <hr />
          </div>
    </div>
  )
}
